import { FC } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import {
  Code,
  Divider,
  Heading,
  Image,
  Link,
  ListItem,
  OrderedList,
  Table,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
  UnorderedList,
} from '@chakra-ui/react';

const components = {
  a: ({ children, href }) => (
    <Link isExternal href={href} textDecoration="underline">
      {children}
    </Link>
  ),
  b: ({ children }) => <Text as="strong">{children}</Text>,
  blockquote: ({ children }) => (
    <Code as="blockquote" p={4}>
      {children}
    </Code>
  ),
  code: ({ children, className }) => <Code className={className}>{children}</Code>,
  del: ({ children }) => <Text as="del">{children}</Text>,
  em: ({ children }) => <Text as="em">{children}</Text>,
  h1: ({ children }) => (
    <Heading as="h1" my={8} fontSize="4xl">
      {children}
    </Heading>
  ),
  h2: ({ children }) => (
    <Heading as="h2" my={6} fontSize="3xl">
      {children}
    </Heading>
  ),
  h3: ({ children }) => (
    <Heading as="h3" my={4} fontSize="2xl">
      {children}
    </Heading>
  ),
  h4: ({ children }) => (
    <Heading as="h4" my={3} fontSize="xl">
      {children}
    </Heading>
  ),
  h5: ({ children }) => (
    <Heading as="h5" my={2} fontSize="lg">
      {children}
    </Heading>
  ),
  h6: ({ children }) => (
    <Heading as="h6" my={1} fontSize="larger">
      {children}
    </Heading>
  ),
  hr: () => <Divider />,
  i: ({ children }) => <Text as="em">{children}</Text>,
  img: ({ alt, src }) => <Image src={src} alt={alt} />,
  li: ({ children }) => <ListItem>{children}</ListItem>,
  ol: ({ children }) => <OrderedList my={4}>{children}</OrderedList>,
  p: ({ children }) => <Text mb={4}>{children}</Text>,
  pre: ({ children, className }) => (
    <Code as="pre" my={1} p={4} className={className}>
      {children}
    </Code>
  ),
  table: ({ children }) => <Table>{children}</Table>,
  tbody: ({ children }) => <Tbody>{children}</Tbody>,
  td: ({ children }) => <Td>{children}</Td>,
  text: ({ children }) => <Text as="span">{children}</Text>,
  tfoot: ({ children }) => <Tfoot>{children}</Tfoot>,
  th: ({ children }) => <Th>{children}</Th>,
  thead: ({ children }) => <Thead>{children}</Thead>,
  tr: ({ children }) => <Tr>{children}</Tr>,
  ul: ({ children }) => <UnorderedList my={2}>{children}</UnorderedList>,
} satisfies Components;

export const Markdown: FC<{ children: string | null | undefined }> = ({ children }) => {
  return <ReactMarkdown components={components}>{children}</ReactMarkdown>;
};
